/**
 * What the Analytics lists' routes share (`/analytics/competitions`,
 * `/analytics/customers`): the sort directions, and how a CSV export's response reads.
 */

/** `order` values every list route takes; the default is `desc`. */
export const SORT_ORDERS = ['desc', 'asc'] as const
export type SortOrder = (typeof SORT_ORDERS)[number]
export const DEFAULT_SORT_ORDER: SortOrder = 'desc'

/** A list's CSV route's answer: the file, and what its headers say about it. */
export interface CsvFile {
  blob: Blob
  /** The name the API gave the file (`Content-Disposition`); null when it named none. */
  filename: string | null
  /** More rows matched than one file carries (`X-Truncated`), so the file is cut. */
  truncated: boolean
  /** The matching rows (`X-Total-Rows`); null when not said. */
  totalRows: number | null
}

/** A CSV response's file and headers. */
export async function csvFileFromResponse(response: Response): Promise<CsvFile> {
  const filename = /filename="([^"]+)"/.exec(response.headers.get('Content-Disposition') ?? '')?.[1] ?? null
  const total = Number.parseInt(response.headers.get('X-Total-Rows') ?? '', 10)
  return {
    blob: await response.blob(),
    filename,
    truncated: response.headers.get('X-Truncated') === 'true',
    totalRows: Number.isFinite(total) ? total : null,
  }
}

/** The name the API gives a list's file (`<noun>-<from>-to-<to>.csv`), for an answer that names none. */
export function csvFilename(noun: string, from: string, to: string): string {
  return `${noun}-${from}-to-${to}.csv`
}
